import React, { useMemo } from 'react';
import './charts.css';

// Compact bar chart for the analytics dashboard. Vertical bars; lowest
// value gets a 4px minimum height so it stays visible. Labels under each
// bar are optional (truncate to a few chars to stay compact).
//
// Props:
//   data:    { label?: string, value: number }[]  — required
//   height:  px (default 96)
//   color:   bar color (default gold)
//   showLabels: bool — default true if data has labels

const MiniBarChart = ({ data = [], height = 96, color = '#00e0ff', showLabels }) => {
  const max = useMemo(() => Math.max(1, ...data.map((d) => Number(d.value) || 0)), [data]);
  const labelsOn = showLabels ?? data.some((d) => d.label);

  return (
    <div className="mini-bar-chart" style={{ height: height + (labelsOn ? 16 : 0) }}>
      <div className="mini-bar-chart-bars" style={{ height }}>
        {data.map((d, i) => {
          const v = Number(d.value) || 0;
          const pct = (v / max) * 100;
          // Floor at 2% so zero bars still register
          const h = Math.max(2, pct);
          return (
            <div key={i} className="mini-bar-chart-col" title={`${d.label || ''}: ${v}`}>
              <div
                className="mini-bar-chart-bar"
                style={{
                  height: `${h}%`,
                  background: `linear-gradient(180deg, ${color}cc 0%, ${color}55 100%)`,
                  borderTop: `1px solid ${color}`,
                }}
              />
            </div>
          );
        })}
      </div>
      {labelsOn && (
        <div className="mini-bar-chart-labels">
          {data.map((d, i) => (
            <span key={i} className="mini-bar-chart-label">{d.label || ''}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default MiniBarChart;
